import { roleuser } from '@edulastic/constants'

// Mirrors backend src/utils/passwordResetPolicy.ts. The backend decides whether
// a district syncs rosters and sends it as district.isSyncingRosters.

// Same as backend lmsFields.
const LMS_FIELDS = [
  'cleverId',
  'newselaId',
  'atlasId',
  'googleId',
  'rosterSourcedId',
  'msoId',
  'cliId',
  'canvasId',
]

export const PASSWORD_RESET_RESTRICTED_MESSAGE =
  'Password reset is disabled because this account is managed by roster sync. A district administrator can reset it if needed.'

const RESTRICTED_ROLES = [
  roleuser.TEACHER,
  roleuser.STUDENT,
  roleuser.SCHOOL_ADMIN,
  roleuser.DISTRICT_ADMIN,
]

const BYPASS_ACTOR_ROLES = [roleuser.DISTRICT_ADMIN, roleuser.EDULASTIC_ADMIN]

const isRestrictingDistrict = (district) =>
  !!district?.isSyncingRosters && !district.allowRosterPasswordReset

// Own profile: hide Change Password for LMS-linked users in a syncing district.
export const isOwnPasswordResetRestricted = (user, district) =>
  RESTRICTED_ROLES.includes(user?.role) &&
  LMS_FIELDS.some((field) => !!user[field]) &&
  isRestrictingDistrict(district)

// Admin tables and Manage Class: rows don't reliably carry LMS ids, so hide
// the action in a syncing district unless the actor can bypass.
export const canShowPasswordResetAction = (actorRole, district) =>
  !isRestrictingDistrict(district) || BYPASS_ACTOR_ROLES.includes(actorRole)
